module.exports = __webpack_public_path__ + "img/u4661.827f9645.svg";